export default "__VITE_ASSET__DPL3usfx__"